import React from 'react';

// Renders a labeled sub-section header used to split a customer-detail tab
// into "Before account deletion" and "After account restoration" buckets.
//
// Props:
//   title:         string  — "Before account deletion" | "After account restoration"
//   captionDate:   string? — formatted boundary date
//   captionPrefix: string? — text shown before captionDate (e.g. "Account deleted on", "Account restored on")
//   isEmpty:       bool    — true when the slice for this bucket has zero rows on the current page
//   children:      node    — the <PaginatedTable> (or equivalent list) for this bucket
const DeletionBucketSection = ({
  title,
  captionDate,
  captionPrefix = 'Account deleted on',
  isEmpty,
  children,
}) => (
  <div className='deletion-bucket-section' style={{ marginBottom: '1.5rem' }}>
    <div className='deletion-bucket-section__header' style={{ fontWeight: 600, marginBottom: '0.25rem' }}>
      {title}
    </div>
    {captionDate && (
      <div className='deletion-bucket-section__caption' style={{ fontSize: '0.85rem', opacity: 0.7, marginBottom: '0.5rem' }}>
        {captionPrefix} {captionDate}
      </div>
    )}
    {isEmpty ? (
      <div className='deletion-bucket-section__empty' style={{ padding: '0.75rem 0', opacity: 0.6 }}>
        No records in this period
      </div>
    ) : (
      children
    )}
  </div>
);

export default DeletionBucketSection;
